import { render, staticRenderFns } from "./TeamSettings.vue?vue&type=template&id=53b6b7ca&scoped=true"
import script from "./TeamSettings.vue?vue&type=script&lang=ts"
export * from "./TeamSettings.vue?vue&type=script&lang=ts"
import style0 from "./TeamSettings.vue?vue&type=style&index=0&id=53b6b7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b6b7ca",
  null
  
)

export default component.exports